export default {
    'misc.action.next'                          : 'Next',
    'misc.action.back'                          : 'Previous',
    'misc.priceValue'                           : '$ {price}',
    'misc.paymentConfirmation.proggressBar'     : 'Transaction in progress',
    'misc.error'                                : 'An error has occurred',
    'misc.beforeUnload'                         : 'Warning ! You will be leaving this page and some information may be lost. Do you want to leave this page ?',
    "misc.select.suggested"                     : "Suggested",
}